/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UtxNFTListNftsParams
} from './schema'



export const utxNFTListNfts = (
    params: UtxNFTListNftsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/nfts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxNFTListNftsQueryKey = (params: UtxNFTListNftsParams,) => [`/nfts`, ...(params ? [params]: [])];

    
export type UtxNFTListNftsQueryResult = NonNullable<Awaited<ReturnType<typeof utxNFTListNfts>>>
export type UtxNFTListNftsQueryError = AxiosError<unknown>

export const useUtxNFTListNfts = <TData = Awaited<ReturnType<typeof utxNFTListNfts>>, TError = AxiosError<unknown>>(
 params: UtxNFTListNftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxNFTListNfts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxNFTListNftsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxNFTListNfts>>> = ({ signal }) => utxNFTListNfts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxNFTListNfts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxNFTNftSummary = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/nfts/summary`,options
    );
  }


export const getUtxNFTNftSummaryQueryKey = () => [`/nfts/summary`];

    
export type UtxNFTNftSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof utxNFTNftSummary>>>
export type UtxNFTNftSummaryQueryError = AxiosError<unknown>

export const useUtxNFTNftSummary = <TData = Awaited<ReturnType<typeof utxNFTNftSummary>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxNFTNftSummary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxNFTNftSummaryQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxNFTNftSummary>>> = ({ signal }) => utxNFTNftSummary({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxNFTNftSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

